import { HiSparkles } from "react-icons/hi";
import { translate } from "ui/i18n";

export function BetaPill({ className }: { className?: string }) {
  return (
    <div
      className={`flex w-fit items-center rounded-[36px] bg-pink-100 px-3 py-1 text-xs font-semibold text-pink-500 ${className}`}
    >
      <HiSparkles size={12} className="me-1" />
      <span className="leading-[20px]">{translate("ns1:AI.Beta")}</span>
    </div>
  );
}
